import { slideDown, slideUp } from "slide-anim";

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split("?");
    if (urlparts.length >= 2) {
        var prefix = encodeURIComponent(parameter) + "=";
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0; ) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
    }
    return url;
}

export const toggleSubMenu = function (el) {
    const submenu = document.querySelector(".edition-menu");

    if (!submenu.classList.contains("edition-menu--open")) {
        slideDown(submenu);
        submenu.classList.add("edition-menu--open");
        el.classList.add("header__submenu-toggle--open");
    } else {
        slideUp(submenu);
        history.replaceState(
            {},
            null,
            removeURLParameter(window.location.href, "menu")
        );
        submenu.classList.remove("edition-menu--open");
        el.classList.remove("header__submenu-toggle--open");
    }
};

export const initSubMenuToggle = function (el) {
    const submenu = document.querySelector(".edition-menu");
    const menuIsOn = el.getAttribute("data-menu-on");

    if (menuIsOn == "true") {
        submenu.style.display = "block";
        submenu.classList.add("edition-menu--open");
        el.classList.add("header__submenu-toggle--open");
    }
};
